interface QrContent {
  locale: string;
  data: Array<{ title: string; description: string }>;
}

export  default  class QrContentLocale {
  public data: Array<{
    title: string;
    description: string;
  }> = [];
  constructor() {
    const { locale } = useI18n();
    this.data =
      dataLocales.find((item) => item.locale == locale.value)?.data ??
      dataLocales[0].data;
  }
}

const dataLocales: Array<QrContent> = [
  {
    locale: "en",
    data: [
      {
        title: "💡 Innovative Functions",
        description:
          "Generate QR codes with functions such as displaying social channels, business info, and collecting customer reviews. Customize with colors, shapes, and logo in just 5 minutes using our pre-designed templates.",
      },
      {
        title: "⚡ Track and Analyze",
        description:
          "Track visitor information with our QR codes, including where and when they scanned your code. Use our analytics feature to gain insight into your business's performance metrics, presented in easy-to-understand charts and graphs.",
      },
      {
        title: "🐱‍🏍 Stay Agile",
        description:
          "Experience ultimate flexibility with Dynamic QR Codes, which use a short URL to point to encrypted content. Modify links or files without reprinting the codes, saving resources and enabling quick response to any campaign changes.",
      },
    ],
  },
  {
    locale: "vi",
    data: [
      {
        title: "💡 Chức năng đổi mới",
        description:
          "Tạo mã QR với các chức năng như hiển thị kênh mạng xã hội, thông tin doanh nghiệp và thu thập đánh giá khách hàng. Tùy chỉnh với màu sắc, hình dạng và logo trong chỉ 5 phút bằng các mẫu được thiết kế sẵn của chúng tôi.",
      },
      {
        title: "⚡ Theo dõi và phân tích",
        description:
          "Theo dõi thông tin khách truy cập với mã QR của chúng tôi, bao gồm nơi và thời điểm họ quét mã của bạn. Sử dụng tính năng phân tích của chúng tôi để có cái nhìn sâu sắc về các chỉ số hiệu suất kinh doanh của bạn, được trình bày dưới dạng biểu đồ và đồ thị dễ hiểu.",
      },
      {
        title: "🐱‍🏍 Linh hoạt",
        description:
          "Trải nghiệm tính linh hoạt tối đa với Mã QR Động, sử dụng đường dẫn ngắn để trỏ đến nội dung được mã hóa. Chỉnh sửa liên kết hoặc tệp mà không cần in lại mã, tiết kiệm tài nguyên và cho phép phản ứng nhanh chóng với bất kỳ thay đổi chiến dịch nào.",
      },
    ],
  },
  {
    locale: "de",
    data: [
      {
        title: "💡 Innovative Funktionen",
        description:
          "Generieren Sie QR-Codes mit Funktionen wie Anzeigen von Social-Media-Kanälen, Geschäftsinformationen und Sammeln von Kundenbewertungen. Passen Sie sie in nur 5 Minuten mit unseren vorgefertigten Vorlagen an Farben, Formen und Logos an.",
      },
      {
        title: "⚡ Verfolgen und analysieren",
        description:
          "Verfolgen Sie Besucherinformationen mit unseren QR-Codes, einschließlich wo und wann sie Ihren Code gescannt haben. Verwenden Sie unsere Analysefunktion, um Einblicke in die Leistungsmetriken Ihres Unternehmens zu gewinnen, die in leicht verständlichen Diagrammen und Grafiken präsentiert werden.",
      },
      {
        title: "🐱‍🏍 Bleiben Sie agil",
        description:
          "Erleben Sie ultimative Flexibilität mit dynamischen QR-Codes, die eine kurze URL verwenden, um auf verschlüsselten Inhalt zu verweisen. Ändern Sie Links oder Dateien ohne erneutes Drucken der Codes, sparen Sie Ressourcen und ermöglichen Sie schnelle Reaktion auf Änderungen in jeder Kampagne.",
      },
    ],
  },
  {
    locale: "fr",
    data: [
      {
        title: "💡 Fonctions innovantes",
        description:
          "Générez des codes QR avec des fonctions telles que l'affichage de canaux sociaux, d'informations commerciales et la collecte d'avis de clients. Personnalisez-les avec des couleurs, des formes et un logo en seulement 5 minutes à l'aide de nos modèles préconçus.",
      },
      {
        title: "⚡ Suivi et analyse",
        description:
          "Suivez les informations des visiteurs avec nos codes QR, y compris où et quand ils ont scanné votre code. Utilisez notre fonctionnalité d'analyse pour obtenir un aperçu des performances de votre entreprise, présenté sous forme de graphiques et de tableaux faciles à comprendre.",
      },
      {
        title: "🐱‍🏍 Restez agile",
        description:
          "Expérimentez une flexibilité ultime avec les codes QR dynamiques, qui utilisent une URL courte pour pointer vers un contenu crypté. Modifiez les liens ou les fichiers sans avoir besoin de réimprimer les codes, en économisant des ressources et permettant une réponse rapide à tout changement de campagne.",
      },
    ],
  },
  {
    locale: "it",
    data: [
      {
        title: "💡 Funzioni innovative",
        description:
          "Genera codici QR con funzioni come visualizzazione dei canali social, informazioni commerciali e raccolta di recensioni dei clienti. Personalizza con colori, forme e logo in soli 5 minuti utilizzando i nostri modelli predefiniti.",
      },
      {
        title: "⚡ Traccia e analizza",
        description:
          "Traccia le informazioni dei visitatori con i nostri codici QR, inclusi dove e quando hanno scansionato il tuo codice. Utilizza la nostra funzione di analisi per ottenere una panoramica delle metriche di prestazione della tua attività, presentate in grafici e tabelle facili da capire.",
      },
      {
        title: "🐱‍🏍 Rimani agile",
        description:
          "Prova l'ultima flessibilità con i codici QR dinamici, che utilizzano un URL breve per puntare a contenuti criptati. Modifica i collegamenti o i file senza ristampare i codici, risparmiando risorse ed abilitando una risposta rapida a qualsiasi cambiamento di campagna.",
      },
    ],
  },
  {
    locale: "es",
    data: [
      {
        title: "💡 Funciones innovadoras",
        description:
          "Genera códigos QR con funciones como mostrar canales sociales, información comercial y recopilación de comentarios de los clientes. Personaliza con colores, formas y logotipo en solo 5 minutos utilizando nuestras plantillas predefinidas.",
      },
      {
        title: "⚡ Rastrea y analiza",
        description:
          "Rastrea la información de los visitantes con nuestros códigos QR, incluyendo dónde y cuándo escanearon tu código. Utiliza nuestra función de análisis para obtener una visión general de las métricas de rendimiento de tu negocio, presentadas en gráficos y tablas fáciles de entender.",
      },
      {
        title: "🐱‍🏍 Mantente ágil",
        description:
          "Experimenta la máxima flexibilidad con los códigos QR dinámicos, que utilizan una URL corta para apuntar a contenido cifrado. Modifica enlaces o archivos sin tener que volver a imprimir los códigos, ahorrando recursos y permitiendo una rápida respuesta a cualquier cambio de campaña.",
      },
    ],
  },
  {
    locale: "ja",
    data: [
      {
        title: "💡 革新的な機能",
        description:
          "ソーシャルチャンネルの表示、ビジネス情報の表示、顧客レビューの収集など、機能を備えたQRコードを生成できます。事前設計されたテンプレートを使用して、色、形、ロゴをカスタマイズすることができます。たった5分で完成します。",
      },
      {
        title: "⚡ 追跡と分析",
        description:
          "QRコードで訪問者情報を追跡できます。スキャンされた場所と日時を含めます。アナリティクス機能を使用して、ビジネスのパフォーマンスメトリックスを理解しやすいグラフやチャートで表示できます。",
      },
      {
        title: "🐱‍🏍 素早く対応",
        description:
          "ダイナミックQRコードを使用すると、暗号化されたコンテンツを指す短いURLを使用できます。リンクやファイルを再印刷することなく変更でき、資源を節約し、キャンペーンの変更に迅速に対応できます。",
      },
    ],
  },
  {
    locale: "zh",
    data: [
      {
        title: "💡 创新功能",
        description:
          "生成具有功能的QR码，例如显示社交渠道、业务信息和收集客户评论。使用我们预先设计的模板，可以在5分钟内自定义颜色、形状和徽标。",
      },
      {
        title: "⚡ 跟踪和分析",
        description:
          "使用我们的QR码跟踪访问者信息，包括何时何地扫描您的码。使用我们的分析功能获得您的业务绩效指标的见解，以易于理解的图表和图形呈现。",
      },
      {
        title: "🐱‍🏍 保持敏捷",
        description:
          "使用动态QR码体验最大的灵活性，使用短链接指向加密内容。修改链接或文件而无需重新印刷码，节省资源并使您能够快速响应任何活动更改。",
      },
    ],
  },
  {
    locale: "pt",
    data: [
      {
        title: "💡 Funções inovadoras",
        description:
          "Gere códigos QR com funções como exibir canais sociais, informações de negócios e coletar avaliações de clientes. Personalize com cores, formas e logotipo em apenas 5 minutos usando nossos modelos pré-projetados.",
      },
      {
        title: "⚡ Rastrear e analisar",
        description:
          "Acompanhe as informações dos visitantes com nossos códigos QR, incluindo onde e quando eles escanearam seu código. Use nossa ferramenta de análise para obter insights sobre as métricas de desempenho de sua empresa, apresentadas em gráficos e tabelas fáceis de entender.",
      },
      {
        title: "🐱‍🏍 Mantenha-se ágil",
        description:
          "Experimente a flexibilidade definitiva com códigos QR dinâmicos, que usam uma URL curta para apontar para conteúdo criptografado. Modifique links ou arquivos sem reimprimir os códigos, economizando recursos e permitindo resposta rápida a quaisquer mudanças na campanha.",
      },
    ],
  },
];
